<mat-card class="decoration-card">
  <mat-card-content>

    <mat-toolbar *ngIf="!isReadonly">

      <span class="example-spacer"></span>

      <button mat-icon-button class="crud_action" matTooltip="add a test" (click)="createTrail()" *ngIf="!isReadonly">
        <mat-icon>plus_one</mat-icon>
      </button>
    </mat-toolbar>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

      <!-- name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
      </ng-container>

      <!-- office Column -->
      <ng-container matColumnDef="office">
        <th mat-header-cell *matHeaderCellDef> Office </th>
        <td mat-cell *matCellDef="let element"> {{element.office}} </td>
      </ng-container>

      <!-- start_date Column -->
      <ng-container matColumnDef="start_date">
        <th mat-header-cell *matHeaderCellDef> Start Date </th>
        <td mat-cell *matCellDef="let element"> {{element.start_date}} </td>
      </ng-container>

      <!-- end_date Column -->
      <ng-container matColumnDef="end_date">
        <th mat-header-cell *matHeaderCellDef> End Date </th>
        <td mat-cell *matCellDef="let element"> {{element.end_date}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row (click)="selectTrail(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

  </mat-card-content>
</mat-card>